import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDefaultShardCatalogDetails } from '../../../../../api';

export const adminSearchShardCatalogDetailsDefaultGetSlice = createGetAsyncSlice({
	name: 'AdminSearchShardCatalogDetailsDefault',
	receive: true,
	request: false,
	requestHandler: getDefaultShardCatalogDetails,
	retainDataOnRequest: true
});
